import { TFormValidator } from "@/interfaces";
import { HELPER } from "@/utils/Helper";

export const COMPANY_NAME_VALIDATORS: TFormValidator[] = [
  (v) => !!v || "The company name is required",
];
export const CUSTOMER_NAME_VALIDATORS: TFormValidator[] = [
  (v) => !!v || "The customer name is required",
];
export const FIRST_NAME_VALIDATORS: TFormValidator[] = [
  (v) => !!v || "The field first name is required",
];
export const LAST_NAME_VALIDATORS: TFormValidator[] = [
  (v) => !!v || "The field last name is required",
];
export const INITIAL_VALIDATORS: TFormValidator[] = [
  (v) => !!v || "The field last name is required",
];
export const EMAIL_VALIDATORS: TFormValidator[] = [
  (v) => !!v || "The field email is required",
  (v) => /.+@.+\..+/.test(v) || "The field email must be valid",
];
export const PHONE_VALIDATORS: TFormValidator[] = [
  (v) => !!v || "The field phone is required",
];
export const MOBILE_VALIDATORS: TFormValidator[] = [
  (v) => !!v || "The field mobile  is required",
];
export const ADDRESS1_RULES: TFormValidator[] = [
  (v) => !!v || "The field address is required",
];
export const PASSWORD_RULES: TFormValidator[] = [
  (v) => !!v || "The field password is required",
];
export const STATUS_RULES: TFormValidator[] = [
  (v) => !!v || "The field status is required",
];
export const USER_RULES: TFormValidator[] = [
  (v) => !!v || "The field user is required",
];
export const MEMO_RULES: TFormValidator[] = [
  (v) => !!v || "The field memo is required",
];
export const TO_RULES: TFormValidator[] = [
  (v) => (v!=null && v != undefined) || "The field TO is required",
];
export const MAKE_RULES: TFormValidator[] = [
  (v) => !!v || "The field make is required",
];
export const MODEL_RULES: TFormValidator[] = [
  (v) => !!v || "The field model is required",
];
export const YEAR_RULES: TFormValidator[] = [
  (v) => !!v || "The field year is required",
];
export const REPAIR_DESCRIPTION_RULES: TFormValidator[] = [
  (v) => !!v || "The field repair description is required",
];
export const USERNAME_RULES: TFormValidator[] = [
  (v) => !!v || "The field username is required",
];
export const REQUIRED_RULE: TFormValidator[] = [
  (v) => !!v || "Field is required",
];
export const TAX_RULE: TFormValidator[] = [
  (v) => (v!=null && v!=undefined) || "Tax is required",
];

export const VIN_RULES: TFormValidator[] = [
  (v) => !!v || "Field is required",
  (v) => v.length>=8 || "Min Vin len is 8",
  (v) => v.length<=17 || "Max Vin len is 17",
];

export const PRICE_REQ_RULES: TFormValidator[] =
[
	(v) => {
		/* THIS RULE ALLOWS A MIN OF ZERO */
		var r = parseFloat(v);
		if ( isNaN(r))
			return "Provide a valid Amount"
		
		if (r < 0)
			return "An greater Amount is required"
		
		return true;
	},
];

export const PRICE_REQ_RULES2: TFormValidator[] =
[
	(v) => {
		/* THIS RULE ALLOWS A MIN GREATER THAN ZERO,
		IT WILL REJECT ZERO. 
		*/
		var r = parseFloat(v);
		if ( isNaN(r))
			return "Provide a valid Amount"
		
		if (r <= 0)
			return "An greater Amount is required"
		
			return true;
	},
];

export const PRICE_QTY_RULES: TFormValidator[] =
[
	(v) => {

		var r = parseFloat(v);
		if ( isNaN(r))
			return "Provide a valid Quantity"

		if (r<=0)
			return "A greater Quantity is required";

		return true;
	},
];

export const LOOSE_WHEEL_RULES: TFormValidator[] =
[
	
	(v) => {
		
		var tmp = (typeof(v)=='number')? v :  parseInt(v);
		if (isNaN(tmp))tmp = 0;

		if (tmp<1)return 'Min is 1 Wheel';
		if (tmp>4) return 'Max is 4 Wheels';
		if (tmp==0) return 'Loose Wheel Count is required';

		return true;
	}
];

